import { getAppStore, setAppStore } from '@/store';
import normalizeCategorySlug from '@/utils/ui/normalizeCategorySlug';
import { Screen } from '@/types';

import type { Deeplink } from '../types';
import { DeeplinkKind } from '../types';

type CategoryDeeplink = Extract<Deeplink, { kind: DeeplinkKind.Category }>;

/**
 * Category deeplink: open the library at the named category and scroll
 * that tab into view.
 */
const categoryHandler = ({ category }: CategoryDeeplink): void => {
  const categorySlug = normalizeCategorySlug(category);
  if (!categorySlug) return;

  const { activeTabSlug } = getAppStore();
  setAppStore({
    ...(activeTabSlug !== categorySlug && { activeTabSlug: categorySlug }),
    screen: Screen.Library,
    shouldScrollToActiveTab: true,
  });
};

export default categoryHandler;
